import { TICKS_PER_BAR, TICKS_PER_BEAT } from '../../shared/tempo';
import type { ClassDefinition, UpgradeDefinition, ZoneDefinition } from '../types';

export interface InkAttack {
  kind: 'ink';
  damage: number;
  cooldownTicks: number;
  speed: number;
  radius: number;
  rangeTicks: number;
  amplitude: number;
  waveTicks: number;
  lane: number;
  laneTicks: number;
}

export interface MotifEffect {
  kind: 'motif';
  distance: number;
  zone: ZoneDefinition;
}

export const TATOUE: ClassDefinition = {
  id: 'tatoue',
  name: 'Le Tatoué',
  role: 'Lâche des dragons d’encre qui traversent toute la foule.',
  color: '#8d86ff',
  maxHp: 130,
  speed: 7,
  radius: 14,
  pickupRadius: 90,
  attack: {
    kind: 'ink',
    damage: 20,
    cooldownTicks: TICKS_PER_BEAT,
    speed: 6.25,
    radius: 16,
    rangeTicks: 48,
    amplitude: 12,
    waveTicks: 15,
    lane: 8,
    laneTicks: 8,
  },
  skill: {
    id: 'motif',
    name: 'Motif',
    description:
      'Tu traces devant toi un mandala qui frappe en rythme les bad vibes qui marchent dessus.',
    cooldownTicks: 3 * TICKS_PER_BAR,
    effect: {
      kind: 'motif',
      distance: 100,
      zone: {
        id: 'motif',
        radius: 64,
        durationBars: 2,
        maxPerPlayer: 2,
        cadence: 'beat',
        damage: 10,
      },
    },
  },
  affinityWeaponIds: ['baton-du-diable'],
};

export const TATOUE_UPGRADES: readonly UpgradeDefinition[] = [
  {
    id: 'encre-fraiche',
    name: 'Encre fraîche',
    description: 'Tes dragons filent plus vite et plus loin.',
    family: 'class',
    classId: 'tatoue',
    modifiers: [{ stat: 'projectileSpeedMul', mul: 1.3 }],
    rarities: {
      rare: {
        description: 'Tes dragons filent nettement plus vite et plus loin.',
        modifiers: [{ stat: 'projectileSpeedMul', mul: 1.6 }],
      },
      legendary: {
        description: 'Tes dragons filent deux fois plus vite et plus loin.',
        modifiers: [{ stat: 'projectileSpeedMul', mul: 2 }],
      },
    },
    maxStacks: 2,
  },
  {
    id: 'dragon-jumeau',
    name: 'Dragon jumeau',
    description: 'Ton dermographe lâche un dragon de plus à chaque temps.',
    family: 'class',
    classId: 'tatoue',
    modifiers: [{ stat: 'projectileCountAdd', add: 1 }],
    rarities: {
      rare: {
        description: 'Ton dermographe lâche deux dragons de plus à chaque temps.',
        modifiers: [{ stat: 'projectileCountAdd', add: 2 }],
      },
      legendary: {
        description: 'Ton dermographe lâche trois dragons de plus à chaque temps.',
        modifiers: [{ stat: 'projectileCountAdd', add: 3 }],
      },
    },
    maxStacks: 2,
  },
  {
    id: 'grand-motif',
    name: 'Grand motif',
    description: 'Ton mandala s’élargit et frappe plus fort.',
    family: 'class',
    classId: 'tatoue',
    modifiers: [
      { stat: 'skillRadiusMul', mul: 1.25 },
      { stat: 'skillPowerMul', mul: 1.2 },
    ],
    rarities: {
      rare: {
        description: 'Ton mandala s’élargit nettement et frappe plus fort.',
        modifiers: [
          { stat: 'skillRadiusMul', mul: 1.5 },
          { stat: 'skillPowerMul', mul: 1.4 },
        ],
      },
      legendary: {
        description: 'Ton mandala s’étend presque au double et frappe fort.',
        modifiers: [
          { stat: 'skillRadiusMul', mul: 1.8 },
          { stat: 'skillPowerMul', mul: 1.6 },
        ],
      },
    },
    maxStacks: 2,
  },
  {
    id: 'main-sure',
    name: 'Main sûre',
    description: 'Ton mandala revient plus vite.',
    family: 'class',
    classId: 'tatoue',
    modifiers: [{ stat: 'skillCooldownMul', mul: 0.64 }],
    rarities: {
      rare: {
        description: 'Ton mandala revient bien plus vite.',
        modifiers: [{ stat: 'skillCooldownMul', mul: 0.36 }],
      },
      legendary: {
        description: 'Ton mandala revient presque aussitôt.',
        modifiers: [{ stat: 'skillCooldownMul', mul: 0.16 }],
      },
    },
    maxStacks: 2,
  },
];
